// extracted by mini-css-extract-plugin
export var footer = "_ou-0";
export var inherit = "_ou-1";
export var input = "_ou-2";
export var modalContent = "_ou-3";
export var quillEditor = "_ou-4";
export var subtitle = "_ou-5";